<template>
  <div class="layout d-flex flex-column">
    <div class="d-flex layout-content scrollbar">
      <div class="content">
        <slot />
        <adificial-atoms-spinner />
      </div>
    </div>
  </div>
</template>

<script>
import FontsMixin from '@/mixins/fonts/fonts.js'

export default {
  mixins: [FontsMixin],
}
</script>

<style scoped>
.content {
  position: relative;
  width: 100vw;
}
.layout {
  overflow: hidden;
  min-height: 100vh;
}
.layout-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

@media (max-width: 768px) {
  .content {
    height: 75vh;
  }
}

@media (min-width: 769px) {
  .content {
    height: 84vh;
  }
}
</style>
